module.exports = __webpack_public_path__ + "img/faq-img.023c9045.png";